import RouteNames from '../../../../app/router/_internals/RouteNames.enum.js';

export default Object.freeze({
	GENERAL: `${RouteNames.SETTINGS_PAGE}-general`,
	NOTIFICATIONS: `${RouteNames.SETTINGS_PAGE}-notifications`,
});
